<template>
    <footer>
        <div class="container">
            <footer class="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
              <div class="col-md-4 d-flex align-items-center">
                <a href="index.html" class="mb-3 me-2 mb-md-0 text-body-secondary text-decoration-none lh-1">
                    <img src="@/images/logo.png"  width="40">
                </a>
                <span class="mb-3 mb-md-0 text-body-secondary">© 2024 My Profile</span>
              </div>
          
              <ul class="nav col-md-4 justify-content-end list-unstyled d-flex">
                <li class="ms-3"><a class="text-body-secondary" href="https://fb.me/mr.somsothea" target="_blank">
                    <img src="images/fb.png" width="26">
                </a></li>
                <li class="ms-3"><a class="text-body-secondary" href="https://www.linkedin.com/in/somsothea" target="_blank">
                  <img src="images/in.png" width="26">
              </a></li>
                <li class="ms-3"><a class="text-body-secondary" href="https://x.com/sotheasom_moc" target="_blank">
                    <img src="images/x.png"  width="26">
                </a></li>
                <li class="ms-3"><a class="text-body-secondary" href="https://t.me/khlinkCloud" target="_blank">
                    <img src="images/telegram.png"  width="26">
                </a></li>
                <li class="ms-3"><a class="text-body-secondary" href="https://youtube.com/@comcambo" target="_blank">
                    <img src="images/yt.png"  width="26">
                </a></li>
              </ul>
            </footer>
          </div>
        </footer>
</template>